import * as React from "react";

const SvgWscLogo = () => (
  <svg
    width="2em"
    height="1em"
    viewBox="0 0 32 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9062 12.8588L8.30165 0H0L10.6397 18H15.9062V12.8588Z"
      fill="white"
    />
    <path
      d="M26.828 12.8588L19.2235 0H10.9194L21.5591 18H26.828V12.8588Z"
      fill="white"
    />
    <path
      d="M29.3655 2.99306L26.7335 3.00694V8.90741L31.9999 0H21.4646"
      fill="#e5ff00"
    />
  </svg>
);

export default SvgWscLogo;
